import { css } from 'styled-components';

// const rootPath = process.env.REACT_APP_AMAZON_ASSETS_URL;

// Media

// hight variations
export const maxHeight = '1080px';
export const midHeight = '1024px';
export const minHeight = '768px';

// width variations
export const maxWidth = '1500px';
export const maxWidth1300 = '1300px';
export const maxWidth1170 = '1170px';
export const minWidthApp = '1100px';
export const maxTablet = '1023px';
export const midTablet = '993px';
export const minTablet = '900px';
export const maxMobile = '767px';
export const midMobile = '575px';
export const smMobile = '480px';
export const xmMobile = '380px';

// export const retina = '(000)';
export const retina = '(-webkit-device-pixel-ratio: 1.25)';
export const retinaOne = '(-webkit-device-pixel-ratio: 1)';

// Fonts
export const primaryFont = 'Roboto';
export const secondaryFont = 'Roboto Slab';

export const wELight = '300';
export const wLight = '400';
export const wMedium = '500';
export const wMBold = '700';
export const wBold = '900';
// Colors
export const primaryBgColor = 'rgb(249,248,246)';
export const SecondaryBgColor = 'rgb(255,255,255)';
export const primaryColor = '#1EC252';
export const primaryActiveColor = 'rgba(194, 238, 209, 0.5)';
export const SecondaryColor = '#001760';
export const TertiaryColor = '#7E7E7E';
export const statusBouncedColor = '#FF9531';
export const statusUnsubscribedColor = '#D50508';
export const boxShadow = '0px 0px 23.90625px -2.8125px rgba(0, 0, 0, 0.12);';
// export const boxShadow = '0px 0px 24px rgba(0, 0, 0, 0.102473)';
export const primaryHeadingColor = '#424B50';
export const secondaryHeadingColor = '#5E7079';

export const noGutter = css`
  margin-left: 0px !important;
  margin-right: 0px !important;
  .ant-col {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
`;

export const scrollbar = css`
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #001760;
    border-radius: 12px;
  }

  &::-webkit-scrollbar-track {
    background: #cfdae8;
    border-radius: 8px;
  }
  & {
    scrollbar-face-color: #001760;
    border-radius: 12px;
  }
`;

export const scrollbarTransparent = css`
  &::-webkit-scrollbar {
    width: 1px;
    height: 1px;
    border-radius: 0px;
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 0px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
  & {
    scrollbar-face-color: transparent;
    border-radius: 0px;
  }
`;

export const textTruncateSnippet = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
`;

export const flexCenter = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const getPersonalityLogo = (personality: string) => {
  if (personality === 'Dominant') return 'https://s3.us-west-2.amazonaws.com/media.xiqonline.com/workBench/images/design/Dominant-d.png';
  else if (personality === 'Influencer') return 'https://s3.us-west-2.amazonaws.com/media.xiqonline.com/workBench/images/design/Influencer-d.png';
  else if (personality === 'Steady') return 'https://s3.us-west-2.amazonaws.com/media.xiqonline.com/workBench/images/design/Steady-d-two.png';
  else if (personality === 'Conscientious')
    return 'https://s3.us-west-2.amazonaws.com/media.xiqonline.com/workBench/images/design/Conscientious-d.png';
  else return 'https://s3.us-west-2.amazonaws.com/media.xiqonline.com/workBench/images/design/other-d-two.png';
};
